import React from "react";

import "./styles.scss";

/**
 * @typedef {Object} Props
 * @property {string} color
 * @property {string} title
 * @property {string} subtitle
 * @property {Object} titleProps
 * @property {Object} subtitleProps
 *
 * Hook evento de timeline
 * @param {*} props - Propiedades visuales del componente
 * @returns React-Component
 *
 * @author David Maldonado
 * @version 1.0.0
 */
export const AtTimelineEvent = ({
  color,
  title,
  subtitle,
  titleProps,
  subtitleProps,
}) => {
  return (
    <>
      <div className="custom-time-line__container">
        <div className="custom-time-line-item__container">
          <svg height="187" width="190" viewBox="0 0 59.531 49.477">
            <g transform="matrix(.99959 0 0 .99838 -100.96 -50)">
              <path
                d="M101.002 69.656h55.492l4.064 4.158-4.064 4.205h-55.492l3.85-4.205z"
                stroke-width="0"
                fill={color}
              ></path>
            </g>
          </svg>
        </div>
        <div className="custom-time-line-text__container">
          <div style={titleProps}>{title}</div>
          <div style={subtitleProps}>{subtitle}</div>
        </div>
      </div>
    </>
  );
};
